import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.171 1H6.245a.83.83 0 0 0-.567.218L1.23 5.711a.817.817 0 0 0 0 1.134l3.926 3.926a.817.817 0 0 0 1.134 0l4.493-4.493A.83.83 0 0 0 11 5.711V1.785C11 1.35 10.651 1 10.171 1ZM8.383 4.49a.875.875 0 0 1-.873-.873c0-.48.393-.872.873-.872s.872.392.872.872-.392.873-.872.873Z" />
  </svg>
);
export default IconPriceLabelSizeXs;
